import React from 'react';
import { LocationsMap } from './LocationsMap';
import { Content } from './Content';
import { Link } from 'react-router-dom';

export const Home = () => {
    return (
        <div className="feature">
            <div className="container">
                <div className="row">
                    <div className="col">
                        <h4>Welcome to the My Name is New York</h4>
                        <p>
                            Please enjoy this interactive experience of Woody Guthrie's time living, writing, and creating some of his most famous works, which all took place in New York City in the 1940s and 1950s.
                            We invite you to walk the streets, ride the buses and subways, or sit down and relax on some of the stoops, park benches, or beaches where
                            Woody Guthrie did &ndash; always strumming away on his guitar, always working on a new song.
                        </p>
                        <p>&quot;All you can write is what you see&quot; &ndash; Woody Guthrie</p>
                        <p>
                            *The first two locations for offered for free.  For the complete experience, we encourage you to <a href="https://store.woodyguthrie.org/products/my-name-is-new-york-book-3-cd-set">purchase the whole story</a>.
                        </p>
                        <h4>
                            A note from the author Nora Guthrie
                        </h4>
                        <p>
                            I was born in Coney Island. On Mermaid Avenue to be exact. I say that because I love streets. I have visceral memories of walking down Mermaid Avenue on a hot summer’s day, hearing street sounds, overhearing conversations, taking in the saltwater smells. I sometimes think I crept out of the ocean like an amphibian and became this human being called Nora. In truth, it was simply that my parents, Woody Guthrie and Marjorie Greenblatt Mazia, settled in Coney Island because it was the cheapest place to live and my Yiddish-speaking grandparents lived across the street in Sea Gate. In addition to the boardwalk’s offerings of knishes and Nathan’s hot dogs, we lived on Bubbie’s blintzes and kasha varnishkes.
                        </p>
                        <p>
                            For the past seventy-four years I’ve lived and walked down many streets in NYC’s boroughs. I consider myself more of a street rat than an inhabitant. Each street contains a particular story, or a particular friend, a good or bad memory, or a favorite place to grab a bite. The streets take me back to the days that shaped me, cuddled me, bored me, hassled me, and helped me—or made me—grow up...
                        </p>

                        <p>
                            <Link to={`/location/1`}>
                                <button className="btn btn-primary">Take a Hike <i className="bi bi-person-walking"></i></button>
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
            <div className="row map-row">
                <div className="col map-col">
                    <LocationsMap/>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <Content/>
                    </div>
                </div>
            </div>
        </div>
    );
};
